<template>
	<div class="color-picker" ref="colorpicker" style="position: relative">
				<v-btn dark small  fab :color="selectedColor" @click="togglePicker"></v-btn>
				<div id="pickerContainer" :style="pickerStyle">
					<chrome-picker  :value="colors" @input="updateFromPicker" v-if="displayPicker"/>
				</div>
	</div>
</template>

<script>
import { Chrome } from 'vue-color'
export default {
    name: 'ColorPicker',
    data() {
        return {
			colors: {
				hex: '#000000'
			},			
            displayPicker: false,        
			pickerStyle: '',
			selectedColor: this.color
        }
    },
    props: {color: String},   
    components:
    {
        'chrome-picker': Chrome
    },        
	mounted() {
		this.setColor(this.color || '#000000');
	},
    methods: {
		setColor(color) {
			this.updateColors(color);
			this.colorValue = color;
		},
		updateColors(color) {
			if(color.slice(0, 1) == '#') {
				this.colors = {
					hex: color
				};
			}
			else if(color.slice(0, 4) == 'rgba') {
				var rgba = color.replace(/^rgba?\(|\s+|\)$/g,'').split(','),
					hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1);
				this.colors = {
					hex: hex,
					a: rgba[3],
				}
			}
		},
		showPicker() {
            var el = this.$refs.colorpicker
            var parent = el.parentNode
			parent.addEventListener('click', this.documentClick);
			this.displayPicker = true;
		},
		hidePicker() {
            var el = this.$refs.colorpicker
            var parent = el.parentNode
			parent.removeEventListener('click', this.documentClick);
			this.displayPicker = false;
		},
		togglePicker() {                        
            
			if(this.displayPicker) {
                this.hidePicker()
            }  else {                 
                this.showPicker();
                
                this.pickerStyle = 'position:absolute; left: 60px; top:-200px';
            } 
		},
		updateFromInput() {
			this.updateColors(this.colorValue);
		},
		updateFromPicker(color) {
			this.colors = color;
			if(color.rgba.a == 1) {
				this.colorValue = color.hex;
			}
			else {
				this.colorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')';
			}
		},
		documentClick(e) {
			var el = this.$refs.colorpicker, target = e.target;
			if(el === target ) {
				this.hidePicker()
			}
		}
	},
    computed: {
        colorValue: {
            get: function() {
                return this.selectedColor
			},  
			set: function(value) {
				this.selectedColor = value
			}    
        }
    },  	
	watch: {
		colorValue(val) {			
			if(val) {
				this.updateColors(val);
				this.$emit('input', val);
				//document.body.style.background = val;
			}
		},
		color: {
			immediate:true,
			handler(val)
			{
				this.colorValue = val				
			}
		}
	}    
}
</script>

<style>

</style>
